module.exports = __webpack_public_path__ + "media/images/icons/speech-bubble-3c504d0828bb577915eed222f0ef8a0c.svg";